import { RequestWithdrawOwnFeatures } from 'features';
import React from 'react';

const RequestWithdrawOwnPage = () => {
  return <RequestWithdrawOwnFeatures />;
};

export default RequestWithdrawOwnPage;
